import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ListEmpty from "../../components/ListEmpty";
import Loading from "../../components/Loading";
import PharmacyBottomNavigation from "../../components/PharmacyBottomNavigation";
import { getPharmacyOrders } from "../../redux/actions/dashboard";
import { getVendorMessages } from "../../redux/actions/messages";
import { closeOrderSafeCallModal } from "../../redux/actions/modals";
import { getPharmacyOrderCancelReasons } from "../../redux/actions/orders";
import { makeSafeCallEmpty } from "../../redux/actions/safeCall";
import { getVendorType } from "../../services/auth"; //09122715967
import toaster from "../../utils/toaster";
import PharmacyOrderAcceptComponent from "./components/modals/PharmacyOrderAcceptComponent";
import PharmacyOrderGeneralAcceptComponent from "./components/modals/PharmacyOrderGeneralAcceptComponent";
import PharmacyOrderReadyComponent from "./components/modals/PharmacyOrderReadyComponent";
import PharmacyOrderRejectComponent from "./components/modals/PharmacyOrderRejectComponent";
import SafeCallModal from "./components/modals/SafeCallModal";
import PharmacyOrdersListMobile from "./components/pharmacy-orders/PharmacyOrdersListMobile";

const MobileDashboardPharmacy = () => {
  const dispatch = useDispatch();
  const list_empty_message = "موردی جهت نمایش وجود ندارد";
  const {
    pharmacy_orders_waiting,
    pharmacy_orders_success,
    pharmacy_active_tile,
    ready_pharmacy_order_success,
  } = useSelector((state) => state.dashboard);
  const {
    pharmacy_order_ready_order,
    pharmacy_order_reject_order,
    pharmacy_order_accept_order,
    pharmacy_order_general_accept_order,
    reject_pharmacy_order_success,
    accept_pharmacy_order_success,
  } = useSelector((state) => state.orders);
  const { make_safe_call_success } = useSelector((state) => state.safeCall);
  const [tiles, setTiles] = useState([]);
  const [orders, setOrders] = useState([]);
  const groupArrayOfObjects = (list, key) => {
    return list.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  useEffect(() => {
    dispatch(getPharmacyOrders());
    dispatch(getPharmacyOrderCancelReasons());
    dispatch(getVendorMessages());
    // let interval = setInterval(() => dispatch(getPharmacyOrders()), 10000);
    return () => {
      // clearInterval(interval);
    };
  }, [dispatch]);
  // useEffect(() => {
  //     if (pharmacy_orders_success.result !== undefined && pharmacy_orders_success.result === "SUCCESS") {
  //         setTiles(pharmacy_orders_success.data.tiles);
  //         let active_orders = pharmacy_orders_success.data.orders.filter((order) => {
  //             return order.drug_store_status === pharmacy_active_tile;
  //         });
  //         setOrders(active_orders);
  //     }
  // }, [dispatch,pharmacy_active_tile, pharmacy_orders_success]);
  useEffect(() => {
    if (
      pharmacy_orders_success.result !== undefined &&
      pharmacy_orders_success.result === "SUCCESS"
    ) {
      setTiles(pharmacy_orders_success.data.tiles);
      let active_orders = pharmacy_orders_success.data.orders.filter(
        (order) => {
          return order.drug_store_status === pharmacy_active_tile;
        }
      );
      if (pharmacy_active_tile === "biker_in_route") {
        let batched_orders = active_orders.filter((order) => {
          return order.batch_order_id !== null;
        });
        let not_batched_orders = active_orders.filter((order) => {
          return order.batch_order_id === null;
        });
        batched_orders.sort((a, b) => {
          return a.batch_order_id - b.batch_order_id;
        });
        let batched_group = groupArrayOfObjects(
          batched_orders,
          "batch_order_id"
        );
        setOrders(Object.values(batched_group).concat(not_batched_orders));
      } else {
        setOrders(active_orders);
      }
    }
  }, [dispatch, pharmacy_active_tile, pharmacy_orders_success]);
  useEffect(() => {
    if (make_safe_call_success && make_safe_call_success.result === "SUCCESS") {
      toaster.success("درخواست تماس امن ارسال شد!");
      dispatch(closeOrderSafeCallModal());
      dispatch(makeSafeCallEmpty());
    }
  }, [dispatch, make_safe_call_success]);
  const vendor_type = getVendorType();

  return (
    <>
      <div className="pharmacy-orders-list-mobile">
        {vendor_type === "DRUG" ? <PharmacyBottomNavigation /> : null}
        {pharmacy_orders_waiting ? (
          <Loading />
        ) : orders.length === 0 ? (
          <ListEmpty message={list_empty_message} />
        ) : (
          <PharmacyOrdersListMobile orders={orders} />
          // orders.map((order, index) => {
          //     return (
          //         renderItemPharmacy(order,index)
          //         // <PharmacyOrderItemMobile key={index} {...order} />
          //     )
          // })
        )}
      </div>
      <PharmacyOrderRejectComponent order={pharmacy_order_reject_order} />
      <PharmacyOrderReadyComponent order={pharmacy_order_ready_order} />
      <PharmacyOrderGeneralAcceptComponent
        order={pharmacy_order_general_accept_order}
      />
      <PharmacyOrderAcceptComponent order={pharmacy_order_accept_order} />
      <SafeCallModal />
    </>
  );
};

export default MobileDashboardPharmacy;
